export enum ClientOrganizationTabs {
  Summary = 'SUMMARY',
  Disposition = 'DISPOSITION',
  Transfers = 'TRANSFERS',
}
